
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Mangesha Maharudra" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Mangesha Maharudra" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Mangesha Maharudra Aarti, Lord Mangesha Aarti, Aarti for Mangesha, Maharudra Aarti, Mangesh Aarti lyrics,'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Mangesha Maharudra Aarti, Aarti for Mangesha, Maharudra Aarti, Lord Mangesha Aarti, Devotional Aarti, Mangesha Deva Aarti, Mangesh Aarti lyrics, Mangesha Bhakti Geet, Maharudra prayer, Lord Shiva Aarti, Aarti in Marathi, devotional aarti, Mangesha Maharudra prayer, Mangesha Maharudra Aarti lyrics in Marathi, Mangesha Bhajan, Mangesha Maharudra Aarti lyrics in english, Mangesha Maharudra Aarti lyrics'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/mangesh.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/mangesh.webp'
          },
          ],
        }
      },
    
      components: {
        },
        data() {
          return {
            title: 'Mangesha Maharudra | Mangesh Aarti - मंगेशा महारुदा (मंगेश आरती)',
            langauageMarathi: true
          }
        },
        layout: 'detailsPage-withoutFooter',
    
        jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/mangesh"
        },
        "headline": "Mangesha Maharudra - मंगेशा महारुदा (मंगेश आरती)",
        "name" : "Mangesha Maharudra - Mangesha Aarti",
        "description": "Explore the full lyrics of Aarti 'Mangesha Maharudra' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/mangesh.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
    
        computed: {
    
        },
        methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
    
      }
    